module.exports = __webpack_public_path__ + "static/media/chrome.fb7a4d16.svg";